import React, { useContext, useMemo } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import BrandingLogo from 'components/BrandingLogo';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { sellingLink } from 'components/ResolveHeader/utils';

import './UserEnterpriseLogo.styles.scss';

type UserEnterpriseLogoProps = {
  className?: string;
  withBorderRadius?: boolean;
  height?: number;
};

const UserEnterpriseLogo: React.FC<UserEnterpriseLogoProps> = (props) => {
  const { className, withBorderRadius = true, height = 40 } = props;

  const classes = classNames('user-enterprise-logo', className);

  const { enterprise, hasEnterpriseLogo } = useContext(CurrentUserContext);

  const userBrandingLogos = useMemo(
    () => ({ logo: enterprise?.logo, mobileLogo: enterprise?.mobileLogo }),
    [enterprise?.logo, enterprise?.mobileLogo],
  );

  if (!hasEnterpriseLogo) return null;

  return (
    <div className={classes}>
      <Link to={sellingLink.href}>
        <BrandingLogo
          withBorderRadius={withBorderRadius}
          brandingLogos={userBrandingLogos}
          height={height}
        />
      </Link>
    </div>
  );
};

export default UserEnterpriseLogo;
